import generated from '../generated/course-catalog.json'
import type { CourseModule } from '../types'

export const MODULES = generated as CourseModule[]

export const MODULE_BY_ID = new Map(MODULES.map((module) => [module.id, module]))

export function modulesForCourse(courseId: string): CourseModule[] {
  return MODULES.filter((module) => module.courseId === courseId)
}
